#import "../fragments/ContactListFields.graphql"

query ContactLists($search: String, $page: Int, $rowsPerPage: Int) {
  contactLists(search: $search, page: $page, rowsPerPage: $rowsPerPage) {
    nodes {
      ...ContactListFields
    }
    count
  }
}
